import "lazysizes";
import "@/style/pc/common.scss";
import "./franchised.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.to(".pc-header", {
  backgroundColor: "#fff",
  height: WindowWidth < 903 ? "70px" : "80px",
  borderBottom: "1px solid #efefef",
  scrollTrigger: {
    trigger: ".franchised-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.to(".pc-header .logo", {
  width: "144px",
  height: "58px",
  scrollTrigger: {
    trigger: ".franchised-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.fromTo(".us-phone, nav .color-f, .us-phone .phone-number, .us-phone .phone-desc",
  { color: "#fff" },
  { color: "#1B451D",
  scrollTrigger: {
    trigger: ".franchised-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});
gsap.to(".logo-img-white", {
  opacity: 0,
  scrollTrigger: {
    trigger: ".franchised-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});


document
  .querySelector(".mobile-menu-btn")
  .addEventListener("click", function () {
    document.querySelector(".mobile-header-nav").classList.add("block");
  });
document
  .querySelector(".mobile-header-nav-close")
  .addEventListener("click", function (e) {
    document.querySelector(".mobile-header-nav").classList.remove("block");
    e.stopPropagation();
    e.preventDefault();
  });

// 移动端下拉菜单交互
document.querySelectorAll('.mobile-nav-parent').forEach(function(parent) {
  parent.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const dropdown = this.parentElement;
    const submenu = dropdown.querySelector('.mobile-submenu');
    const arrow = this.querySelector('.dropdown-arrow');
    
    // 切换当前菜单
    this.classList.toggle('active');
    submenu.classList.toggle('show');
  });
});

var WindowWidth = 0;
function updateScreenSize() {
  WindowWidth = document.documentElement.clientWidth;
}
updateScreenSize();
window.addEventListener("resize", updateScreenSize);

